export const TestIds = {
  content: 'mesh-container-content',
  inlineContent: 'inline-content',
} as const;
